import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceAndNoteTableComponent } from '../../price-and-note-table/price-and-note-table.component';
import { NotesComponent } from '../../notes/notes.component';
import { PriceListTransferFee } from '../../../models/pricelist-transfer.model';
import { CompanyEnum } from '../../../models/company.model';
import { Note, ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../../models/types';
import { getKilTransferFeeLabels } from '../../../utils/table-utils';
import { extractNotes } from '../../../utils/pricelist.functions';

@Component({
  standalone: true,
  imports: [CommonModule, PriceAndNoteTableComponent, NotesComponent],
  selector: 'lx-price-lists-portal-positively-transfer-table',
  templateUrl: './positively-transfer-table.component.html',
  styleUrls: ['./positively-transfer-table.component.scss'],
})
export class PositivelyTransferTableComponent implements OnInit {
  @Input() transfers: PriceListTransferFee | undefined;

  dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  columnLabels: ProductsWithPriceAndNoteLabels | undefined;
  notes: Note[] | undefined;
  notationMarks: Record<string, string> | undefined;

  company = CompanyEnum.KIL;

  ngOnInit(): void {
    this.columnLabels = getKilTransferFeeLabels();

    if (this.transfers?.products) {
      this.dataSource = this.transfers.products.map(({ name, additionalInfo, prices }) => ({
        name,
        price: prices ? prices[0].price : null,
        additionalInfo,
      }));
    }

    if (this.transfers?.notes) {
      [this.notes, this.notationMarks] = extractNotes(this.transfers.notes);
    }
  }
}
